import { Quotes } from "@phosphor-icons/react";

/**
 * REAL testimonials only — every entry must be a verbatim quote supplied
 * by the actual owner with permission. Never invent or paraphrase.
 *
 * Shape: { quote, name, truck, location?, image? }
 */
const TESTIMONIALS = [
  {
    quote:
      "The Truck Trackr has changed the game for OBX lemonade. Customers can track us down easily and we are able to gain customers in the ever growing market. 10/10 would recommend the Truck Trackr to any food trucker, customer, or person that just loves food trucks.",
    name: "Derek Eisenberger",
    truck: "OBX Lemonade",
    image: "/testimonial-obx-lemonade.png",
  },
  {
    quote:
      "As a food truck owner, we love how easy this app makes it for customers to find us! It's simple, convenient, and helps people discover local food trucks they might otherwise miss.",
    name: "Kristy Miranda",
    truck: "Walk-O-Taco",
    image: "/testimonial-walk-o-taco.jpg",
  },
];

function Card({ t, large }) {
  return (
    <figure
      className={`rounded-2xl border border-border bg-card ${large ? "p-7 sm:p-9" : "p-6"} flex flex-col`}
      data-testid="testimonial-card"
    >
      <Quotes weight="fill" className="h-6 w-6 text-primary/60" />
      <blockquote className={`mt-3 ${large ? "text-base sm:text-lg" : "text-sm"} leading-relaxed flex-1`}>
        {t.quote}
      </blockquote>
      <figcaption className="mt-5 flex items-center gap-3">
        {t.image && (
          <img
            src={t.image}
            alt={`${t.truck} logo`}
            loading="lazy"
            className="h-11 w-11 rounded-full object-cover border border-border flex-none"
          />
        )}
        <div className="min-w-0">
          <div className="text-sm font-semibold truncate">{t.name}</div>
          <div className="text-xs text-muted-foreground truncate">
            {t.truck}
            {t.location ? ` · ${t.location}` : ""}
          </div>
        </div>
      </figcaption>
    </figure>
  );
}

export default function Testimonials() {
  const count = TESTIMONIALS.length;
  if (count === 0) return null;
  return (
    <section
      className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-20"
      data-testid="testimonials-section"
    >
      <span className="text-xs uppercase tracking-[0.2em] text-primary font-medium">
        From working trucks
      </span>
      <h2 className="mt-3 font-display font-bold tracking-tight text-2xl sm:text-3xl">
        Built for food trucks. <span className="text-primary">Used by food trucks.</span>
      </h2>
      {count === 1 ? (
        <div className="mt-6 max-w-2xl">
          <Card t={TESTIMONIALS[0]} large />
        </div>
      ) : (
        <div className={`mt-6 grid gap-4 md:grid-cols-2 ${count >= 3 ? "lg:grid-cols-3" : ""}`}>
          {TESTIMONIALS.map((t) => (
            <Card key={t.name + t.truck} t={t} />
          ))}
        </div>
      )}
    </section>
  );
}
